import * as types from "../ActionType";
import axios from "axios";
import { notifyError, notifysuccess, staticc } from "../../Components/General/Notification";

const getSubCat = (subCat) => {
    return ({
        type: types.GET_ALL_SUBCATEGORY,
        payload: subCat
    })
}

const addSubCat = () => {
    return ({
        type: types.ADD_SUBCATEGORY
    })
}

const delSubCat = () => {
    return ({
        type: types.DELETE_SUBCATEGORY
    })
}

const editSubCat = () => {
    return ({
        type: types.EDIT_SUBCATEGORY
    })
}

const getSubCatById = (subCatById) => {
    return ({
        type: types.GET_SUBCATEGORY_BY_ID,
        payload: subCatById
    })
}

const getdays = (dayss) => {
    return ({
        type: types.GET_ALL_DAYS,
        payload: dayss
    })
}


export const loadSubCategory = () => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${staticc}/api/subcategories`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(getSubCat(res.data.data));
            }
        }).catch((err) => {
            console.log(err)
            notifyError(err.response.data)
        })
    }
}

export const postSubCategory = (category_id, name, name_ar, image, thumbnail, setloabBtn) => {
    return function (dispatch) {
        setloabBtn(true)
        let token = localStorage.getItem("tokenA");
        const Dataa = new FormData();
        Dataa.append('name', name);
        Dataa.append('name_ar', name_ar);
        Dataa.append('category_id', category_id);
        Dataa.append('image', image);
        Dataa.append('thumbnail', thumbnail);
        axios.post(`${staticc}/api/subcategory_add`, Dataa, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(addSubCat());
                dispatch(loadSubCategory());
                notifysuccess(res.data.message)
                setloabBtn(false)
            }
        }).catch((err) => {
            console.log(err)
            setloabBtn(false)
            notifyError(err.response.data)
        })
    }
}

export const deleteSubCategory = (id) => {
    return function (dispatch) {
        //setloabBtn(true)
        console.log(id)
        let token = localStorage.getItem("tokenA");
        axios.post(`${staticc}/api/subcategory_delete`, { id }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(delSubCat());
                dispatch(loadSubCategory());
                notifysuccess(res.data.message)
                //setloabBtn(false)
            }
        }).catch((err) => {
            console.log(err)
            //setloabBtn(false)
            notifyError(err.response.data)
        })
    }
}

export const updateSubCategory = (id, category_id, name, name_ar, image, thumbnail, setloabBtn) => {
    return function (dispatch) {
        setloabBtn(true)
        let token = localStorage.getItem("tokenA");
        const Dataa = new FormData();
        if (image != '') {
            Dataa.append('image', image);
        }
        if (thumbnail != '') {
            Dataa.append('thumbnail', thumbnail);
        }
        Dataa.append('id', id);
        Dataa.append('name', name);
        Dataa.append('name_ar', name_ar);
        Dataa.append('category_id', category_id);

        axios.post(`${staticc}/api/subcategory_update`, Dataa, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(editSubCat());
                notifysuccess(res.data.message)
                dispatch(loadSubCategory());
                setloabBtn(false)
            }
        }).catch((err) => {
            console.log(err)
            setloabBtn(false)
            notifyError(err.response.data)
        })
    }
}

export const loadSubCategoryById = (id) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${staticc}/api/subcategories?category_id=${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(getSubCatById(res.data.data.subcategoris));
            }
        }).catch((err) => {
            console.log(err)
            notifyError(err.response.data)
        })
    }
}

export const loadDays = () => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${staticc}/api/days`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(getdays(res.data.data));
            }
        }).catch((err) => {
            console.log(err)
            notifyError(err.response.data)
        })
    }
}



